export const currencyNames = {
  AUD: 'Австралийский доллар',
  AZN: 'Азербайджанский манат',
  AMD: 'Армянский драм',
  THB: 'Тайский бат',
  BYN: 'Белорусский рубль',
  BRL: 'Бразильский реал',
  KRW: 'Южнокорейская вона',
  HKD: 'Гонконгский доллар',
  UAH: 'Украинская гривна',
  DKK: 'Датская крона',
  AED: 'Дирхам ОАЭ',
  USD: 'Доллар США',
  EUR: 'Евро',
  PLN: 'Польский злотый',
  INR: 'Индийская рупия',
  IRR: 'Иранский реал',
  JPY: 'Японская йена',
  CAD: 'Канадский доллар',
  KWD: 'Кувейтский динар',
  GEL: 'Грузинский лари',
  MYR: 'Малайзийский ринггит',
  MXN: 'Мексиканское песо',
  MDL: 'Молдавский лей',
  TRY: 'Турецкая лира',
  NOK: 'Норвежская крона',
  RUB: 'Российский рубль',
  ZAR: 'Южноафриканский рэнд',
  SAR: 'Саудовский риял',
  SGD: 'Сингапурский доллар',
  KGS: 'Киргизский сом',
  TJS: 'Таджикский сомони',
  UZS: 'Узбекский сум',
  HUF: 'Венгерский форинт',
  GBP: 'Британский фунт',
  CZK: 'Чешская крона',
  SEK: 'Шведская крона',
  CHF: 'Швейцарский франк',
  CNY: 'Китайский юань'
};

export const currencyForSelect = [
  {value: 'AUD', label: 'AUD / Австралийский доллар'},
  {value: 'AZN', label: 'AZN / Азербайджанский манат'},
  {value: 'AMD', label: 'AMD / Армянский драм'},
  {value: 'BYN', label: 'BYN / Белорусский рубль'},
  {value: 'BRL', label: 'BRL / Бразильский реал'},
  {value: 'GBP', label: 'GBP / Британский фунт'},
  {value: 'HUF', label: 'HUF / Венгерский форинт'},
  {value: 'HKD', label: 'HKD / Гонконгский доллар'},
  {value: 'GEL', label: 'GEL / Грузинский лари'},
  {value: 'DKK', label: 'DKK / Датская крона'},
  {value: 'AED', label: 'AED / Дирхам ОАЭ'},
  {value: 'USD', label: 'USD / Доллар США'},
  {value: 'EUR', label: 'EUR / Евро'},
  {value: 'INR', label: 'INR / Индийская рупия'},
  {value: 'IRR', label: 'IRR / Иранский реал'},
  {value: 'CAD', label: 'CAD / Канадский доллар'},
  {value: 'KGS', label: 'KGS / Киргизский сом'},
  {value: 'CNY', label: 'CNY / Китайский юань'},
  {value: 'KWD', label: 'KWD / Кувейтский динар'},
  {value: 'MYR', label: 'MYR / Малайзийский ринггит'},
  {value: 'MXN', label: 'MXN / Мексиканское песо'},
  {value: 'MDL', label: 'MDL / Молдавский лей'},
  {value: 'NOK', label: 'NOK / Норвежская крона'},
  {value: 'PLN', label: 'PLN / Польский злотый'},
  {value: 'RUB', label: 'RUB / Российский рубль'},
  {value: 'SAR', label: 'SAR / Саудовский риял'},
  {value: 'SGD', label: 'SGD / Сингапурский доллар'},
  {value: 'TJS', label: 'TJS / Таджикский сомони'},
  {value: 'THB', label: 'THB / Тайский бат'},
  {value: 'TRY', label: 'TRY / Турецкая лира'},
  {value: 'UZS', label: 'UZS / Узбекский сум'},
  {value: 'UAH', label: 'UAH / Украинская гривна'},
  {value: 'CZK', label: 'CZK / Чешская крона'},
  {value: 'SEK', label: 'SEK / Шведская крона'},
  {value: 'CHF', label: 'CHF / Швейцарский франк'},
  {value: 'ZAR', label: 'ZAR / Южноафриканский рэнд'},
  {value: 'KRW', label: 'KRW / Южнокорейская вона'},
  {value: 'JPY', label: 'JPY / Японская йена'}
];

export const groupedCurrency = [
  {
    label: 'Популярные',
    options: [
      {value: 'USD', label: 'USD / Доллар США'},
      {value: 'EUR', label: 'EUR / Евро'},
      {value: 'RUB', label: 'RUB / Российский рубль'},
      {value: 'CNY', label: 'CNY / Китайский юань'}
    ]
  },
  {
    label: 'А',
    options: [
      {value: 'AUD', label: 'AUD / Австралийский доллар'},
      {value: 'AZN', label: 'AZN / Азербайджанский манат'},
      {value: 'AMD', label: 'AMD / Армянский драм'}
    ]
  },
  {
    label: 'Б',
    options: [
      {value: 'BYN', label: 'BYN / Белорусский рубль'},
      {value: 'BRL', label: 'BRL / Бразильский реал'},
      {value: 'GBP', label: 'GBP / Британский фунт'}
    ]
  },
  {
    label: 'В',
    options: [
      {value: 'HUF', label: 'HUF / Венгерский форинт'}

    ]
  },
  {
    label: 'Г',
    options: [
      {value: 'HKD', label: 'HKD / Гонконгский доллар'},
      {value: 'GEL', label: 'GEL / Грузинский лари'}
    ]
  },
  {
    label: 'Д',
    options: [
      {value: 'DKK', label: 'DKK / Датская крона'},
      {value: 'AED', label: 'AED / Дирхам ОАЭ'}
    ]
  },
  {
    label: 'И',
    options: [
      {value: 'INR', label: 'INR / Индийская рупия'},
      {value: 'IRR', label: 'IRR / Иранский реал'}
    ]
  },
  {
    label: 'К',
    options: [
      {value: 'CAD', label: 'CAD / Канадский доллар'},
      {value: 'KGS', label: 'KGS / Киргизский сом'},
      {value: 'KWD', label: 'KWD / Кувейтский динар'}
    ]
  },
  {
    label: 'М',
    options: [
      {value: 'MYR', label: 'MYR / Малайзийский ринггит'},
      {value: 'MXN', label: 'MXN / Мексиканское песо'},
      {value: 'MDL', label: 'MDL / Молдавский лей'}
    ]
  },
  {
    label: 'Н',
    options: [
      {value: 'NOK', label: 'NOK / Норвежская крона'}

    ]
  },
  {
    label: 'П',
    options: [
      {value: 'PLN', label: 'PLN / Польский злотый'}

    ]
  },
  {
    label: 'С',
    options: [
      {value: 'SAR', label: 'SAR / Саудовский риял'},
      {value: 'SGD', label: 'SGD / Сингапурский доллар'}
    ]
  },
  {
    label: 'Т',
    options: [
      {value: 'TJS', label: 'TJS / Таджикский сомони'},
      {value: 'THB', label: 'THB / Тайский бат'},
      {value: 'TRY', label: 'TRY / Турецкая лира'}
    ]
  },
  {
    label: 'У',
    options: [
      {value: 'UZS', label: 'UZS / Узбекский сум'},
      {value: 'UAH', label: 'UAH / Украинская гривна'}
    ]
  },
  {
    label: 'Ч',
    options: [
      {value: 'CZK', label: 'CZK / Чешская крона'}

    ]
  },
  {
    label: 'Ш',
    options: [
      {value: 'SEK', label: 'SEK / Шведская крона'},
      {value: 'CHF', label: 'CHF / Швейцарский франк'}
    ]
  },
  {
    label: 'Ю',
    options: [
      {value: 'ZAR', label: 'ZAR / Южноафриканский рэнд'},
      {value: 'KRW', label: 'KRW / Южнокорейская вона'}
    ]
  },
  {
    label: 'Я',
    options: [
      {value: 'JPY', label: 'JPY / Японская йена'}
    ]
  }
];
